import { getMarkerStyles } from 'app/core/markers/models';
import { strokeMarkerRenderer } from './painters';
export const renderRectMarker = (marker, opts, ctx) => {
    const item = marker;
    const painter = (pCtx) => {
        pCtx.beginPath();
        // to get correct rect
        pCtx.rect(item.x, item.y, item.endX, item.endY);
        pCtx.closePath();
    };
    ctx.save();
    strokeMarkerRenderer(ctx, Object.assign(Object.assign({}, getMarkerStyles(marker)), { strokeJoin: 'miter', strokeCap: 'square' }), painter, opts);
    ctx.restore();
};
